<template>
  <section class="relative bg-elevated pt-8 md:pt-0 min-h-auto md:h-[50vh]">
    <UContainer>
        <div class="flex flex-col md:flex-row items-center gap-16 md:gap-4">
               <UCarousel
                    v-slot="{ item }"
                    fade
                    :dots="items.length > 1"
                    :items="items"
                    class="w-full md:w-1/2"
                      :autoplay="autoplay"
                    :loop="true"
                    @select="onSlideChange"
                    :ui="{
      dots: 'md:-bottom-4 md:justify-start',
      dot: 'w-2 h-2'
    }"
                >
                     <div class="pr-4 py-8 flex-col justify-center text-center md:text-left">
                       <h3 class="text-2xl md:text-3xl font-bold mb-4 text-gray-900 dark:text-gray-100">{{ item.title }}</h3>
                       <p class="text-lg md:text-xl text-gray-600 dark:text-gray-400 mb-6">{{ item.description }}</p>
                          <div class="flex justify-center md:justify-start gap-3">
                            <UButton
                                v-if="item.primaryAction"
                              :to="item.primaryAction.to"
                              variant="outline"
                              size="xl"
                            >
                              {{ item.primaryAction.label }}
                            </UButton>
                            <UButton
                                v-if="item.secondaryAction"
                              :to="item.secondaryAction.to"
                              variant="solid"
                              size="xl"
                            >
                              {{ item.secondaryAction.label }}
                            </UButton>
                            </div>
                        </div>
                </UCarousel>

                <div class="w-full md:w-1/2" @keydown.capture.stop>
  <UCarousel
                      v-slot="{ item }"
                      fade
                      :items="items"
                      class="w-full"
                      auto-height
                        ref="imageCarousel"
                        :watch-drag="false"
                   
                    @keydown.left.prevent
                      @keydown.right.prevent
                 >
                        <div class="w-full h-96 md:h-[50vh]" :style="{
                            backgroundImage: `url(${item.image})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }"></div>
                 </UCarousel>
                </div>
        </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
const { t: $t } = useI18n()

interface HeroAction {
  label: string
  to: string
}

interface HeroItem {
  title: string
  description: string
  primaryAction: HeroAction
  secondaryAction?: HeroAction
  image: string
  imageAlt: string
}

const imageCarousel = useTemplateRef('imageCarousel')

const onSlideChange = (index: number) => {
 imageCarousel.value?.emblaApi?.scrollTo(index)
}

const catalogService = useCatalogService();

const { locale } = useI18n();

const {
  data
} = await useAsyncData(() => catalogService.getHomepageCollections(), { watch: [locale], default: () => ({ data: [] }) })

const collections = computed(() => data.value.data)

const autoplay = false; /*{ delay: 4000 }*/

const localePath = useLocalePath()


const items = ref<HeroItem[]>(
  collections.value.map(collection => ({
    title: collection.name,
    description: collection.description || '',
    primaryAction: { label: $t('Shop now'), to: localePath({ name: 'catalog-collection', params: { collection: collection.slug } }) },
    image: collection.images.length > 0 ? collection.images[0]!.url : ``,
    imageAlt: collection.images.length > 0 ? collection.images[0]!.url : ``,
  }))
)
</script>
